/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DocTextIcon24Solid = forwardRef('DocTextIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.05 2H8a4 4 0 0 0-4 4v12a4 4 0 0 0 4 4h8a4 4 0 0 0 4-4v-7.95h-5.2a2.75 2.75 0 0 1-2.75-2.75V2ZM7.5 16.8a.75.75 0 0 1 .75-.75h4.25a.75.75 0 0 1 0 1.5H8.25a.75.75 0 0 1-.75-.75Zm.75-3.75a.75.75 0 0 0 0 1.5h7.5a.75.75 0 1 0 0-1.5h-7.5Z" }),
        React.createElement("path", { d: "M20 8.55v-.04l-6.45-6.45V7.3c0 .69.56 1.25 1.25 1.25H20Z" })));
});
